import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * PaymentRedirectHandler
 */
const PaymentRedirectHandler = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const paymentStatus = searchParams.get('payment_status');
        const sessionId = searchParams.get('session_id');

        if (paymentStatus === 'success' && sessionId) {
            // console.log('🔄 Universal Redirect: Payment Success detected');
            navigate(`/payment/success?session_id=${sessionId}`, { replace: true });
        } else if (paymentStatus === 'cancel') {
            // console.log('🔄 Universal Redirect: Payment Cancel detected');
            navigate('/payment/cancel', { replace: true });
        }
    }, [searchParams, navigate]);

    return null;
};

export default PaymentRedirectHandler;
